export const GROUP_KEY = 'group'
export const COUNTRIES_KEY = 'countries'

export const FETCH_GROUP = 'Group/FETCH_GROUP'
export const FETCH_GROUP_SUCCESS = 'Group/FETCH_GROUP_SUCCESS'
export const FETCH_GROUP_ERROR = 'Group/FETCH_GROUP_ERROR'
export const FETCH_GROUP_DONE = 'Group/FETCH_GROUP_DONE'
